import * as React from 'react';
import { Modal } from 'react-bootstrap';
import * as DateHelpers from './DateHelpers';
import { toast } from 'react-toastify';

interface RunSheetLinkedJobProps {
    linkedJobs: AllocatedJob[];
    truckOptions: TruckListOption[];
    showModal: boolean;
    hideModal(): void;
    editJob(jobIndex: number, itemIndex: number): void;
    updateData(linkedJobs: AllocatedJob[]): void;
    saveModal(): void;
}

interface LinkedJobPopup {
    truckFilterId: number;
    errors: any;
}

interface AllocatedJob {
    id: number; //runsheet Id
    scheduleId: number;
    jobId: number;
    jobNumber: number;
    itemIndex: number;
    truckId: number;
    truck: string;
    unitNumber: string;
    siteAddress: string;
    departureTime: string;
    siteArrivalTime: string;
    downTime: string;
    siteCompletionTime: string;
    departureTimeFormatted: string;
    siteArrivalTimeFormatted: string;
    siteCompletionTimeFormatted: string;
    estTimeMins: number;
    callout: boolean;
    driverNotes: string;
    items: AllocatedJobItem[];
    isDirty: boolean;
    isReschedule: boolean;
    error: string;
}

interface AllocatedJobItem {
    id: number;
    itemIndex: number;
    unitNumber: string;
    typeId: number;
    type: string;
    manualItem: boolean;
    description: string;
    itemId: number;
    item: string;
    unitOfMeasure: string;
    quantityTotal: number;
    quantityScheduled: number;
    quantity: number;
    quantityLost: number;
    quantityType: string;
    reschedule: boolean;
    price: number;
    overhireRate: number;
    calloutItem: boolean;
    scheduleNotes: string;
    kwikstageItems: AllocateJobKwikstageItem[];
    isCustomerPickup: boolean;
    isDirty: boolean;
}

interface AllocateJobKwikstageItem {
    scheduleKwikstageId: number;
    scheduleId: number;
    starterBayId: number;
    starterBay: string;
    liftId: number;
    lift: string;
    bays: number;
    baysComplete: number;
    baysLost: number;
    reschedule: boolean;
}

interface TruckListOption {
    id: number,
    name: string,
    registrationNumber: string
}

export default class RunsheetLinkedJobPopup extends React.Component<RunSheetLinkedJobProps, LinkedJobPopup> {
    constructor(props: any) {
        super(props);

        this.state = {
            truckFilterId: -1,
            errors: {}

        };

    }

    //edit job 
    editJob = (e: any, jobIndex: number, itemIndex: number) => {
        e.preventDefault();

        this.props.editJob(jobIndex, itemIndex);
    }

  
    //end edit job modal

    //truck filter change
    handleTruckChange = (e: any) => {
        e.preventDefault();
        this.setState({ truckFilterId: e.target.value, errors: {} });
    }

    //grid item changed
    onCellChange = (itemIndex: number, e: any) => {
        //update item that has changed
        var linkedJobs = this.props.linkedJobs;
        var linkedJob = linkedJobs[itemIndex];
        let newLinkedJob: any = {};
        newLinkedJob = linkedJob;
        newLinkedJob[e.target.name] = e.target.value;
        linkedJob.isDirty = true;

        this.setState({ errors: {} });
        this.props.updateData(linkedJobs);

        this.validateTimes(itemIndex);
    }

    onSubgridCellChange = (jobIndex: number, itemIndex: number, e: any) => {
        //update item that has changed
        var linkedJobs = this.props.linkedJobs;
        var linkedJob = linkedJobs[jobIndex];
        var linkedItem = linkedJob.items[itemIndex];
        let newLinkedItem: any = {};
        newLinkedItem = linkedItem;
        newLinkedItem[e.target.name] = e.target.value;
        linkedItem.isDirty = true;
        //update the job as isDirty too so validation works
        linkedJob.isDirty = true;

        this.setState({ errors: {} });
        this.props.updateData(linkedJobs);
    }

    onSubgridCellCheckChange = (jobIndex: number, itemIndex: number, e: any) => {
        //update item that has changed
        var linkedJobs = this.props.linkedJobs;
        var linkedJob = linkedJobs[jobIndex];
        var linkedItem = linkedJob.items[itemIndex];
        let newLinkedItem: any = {};
        newLinkedItem = linkedItem;
        newLinkedItem[e.target.name] = e.target.checked;

        linkedItem.isDirty = true;
        //update the job as isDirty too so validation works
        linkedJob.isDirty = true;

        var jobsReschedule = linkedJob.items.filter(ks => ks.reschedule);
        if (jobsReschedule && jobsReschedule.length > 0) {
            linkedJob.isReschedule = true;
        } else {
            linkedJob.isReschedule = false;
        }
        linkedJob.error = "";

        this.setState({ errors: {} });
        this.props.updateData(linkedJobs);
    }

    onKwikstageSubgridCellChange = (e: any, jobIndex: number, itemIndex: number, kwikstateIndex: number) => {
        var linkedJobs = this.props.linkedJobs;
        var linkedJob = linkedJobs[jobIndex];
        var linkedItem = linkedJob.items[itemIndex];
        var kwikstageItem = linkedItem.kwikstageItems[kwikstateIndex];

        let newkwikstageItem: any = {};
        newkwikstageItem = kwikstageItem;
        newkwikstageItem[e.target.name] = e.target.value;
        linkedItem.isDirty = true;
        //update the job as isDirty too so validation works
        linkedJob.isDirty = true;

        this.setState({ errors: {} });
        this.props.updateData(linkedJobs);
    }

    onKwikstageSubgridCheckChange = (e: any, jobIndex: number, itemIndex: number, kwikstateIndex: number) => {
        var linkedJobs = this.props.linkedJobs;
        var linkedJob = linkedJobs[jobIndex];
        var linkedItem = linkedJob.items[itemIndex];
        var kwikstageItem = linkedItem.kwikstageItems[kwikstateIndex];

        let newkwikstageItem: any = {};
        newkwikstageItem = kwikstageItem;
        newkwikstageItem[e.target.name] = e.target.checked;
        linkedJob.error = "";

        //check to see if any items are set to reschedule and update main job
        var jobsReschedule = linkedItem.kwikstageItems.filter(ks => ks.reschedule);
        if (jobsReschedule && jobsReschedule.length > 0) {
            linkedJob.isReschedule = true;
        } else {
            linkedJob.isReschedule = false;
        }

        this.setState({ errors: {} });
        this.props.updateData(linkedJobs);
    }

    validateTimes = (itemIndex: number) => {
        var linkedJobs = this.props.linkedJobs;
        var linkedJob = linkedJobs[itemIndex];
        var rescheduleJobs = linkedJob.items.filter(l => l.reschedule).length;

        var error = "";

        //check arrival > depart 
        if (linkedJob.siteArrivalTimeFormatted && linkedJob.departureTimeFormatted) {
            if (DateHelpers.validTimeAmount(linkedJob.siteArrivalTimeFormatted) && DateHelpers.validTimeAmount(linkedJob.departureTimeFormatted)) {
                if (!DateHelpers.compareTimeGreater(linkedJob.departureTimeFormatted, linkedJob.siteArrivalTimeFormatted)) {
                    error += "Arrival Time needs to be > than Departure Time \n";
                }
            }
        }
        //check completion > arrival and completion - arrival is within estimated time +- 1 hr
        if (linkedJob.siteArrivalTimeFormatted && linkedJob.siteCompletionTimeFormatted) {
            if (DateHelpers.validTimeAmount(linkedJob.siteArrivalTimeFormatted) && DateHelpers.validTimeAmount(linkedJob.siteCompletionTimeFormatted)) {
                if (!DateHelpers.compareTimeGreater(linkedJob.siteArrivalTimeFormatted, linkedJob.siteCompletionTimeFormatted)) {
                    error += "Completion Time needs to be > than Arrival Time \n";
                } else if (linkedJob.estTimeMins > 0) {
                    //check the estimated time
                    var timeDiffMins = DateHelpers.getTimeDifferenceMins(linkedJob.siteArrivalTimeFormatted, linkedJob.siteCompletionTimeFormatted);
                    var estTimeMins = linkedJob.estTimeMins;

                    //check that time difference mins is not more than 1 hour > estimated time mins
                    var estTimeMins1Hr = estTimeMins + 60;
                    if (timeDiffMins > estTimeMins1Hr) {
                        error += "Difference between Arrival and Completion times is > Estimated Time (+ 1 hr) \n";
                    }

                    //check that time difference mins is not more than 1 hr < estimated time mins
                    //ignore this rule if we are rescheduling some items as the estimated time will be incorrect
                    if (estTimeMins > 60 && rescheduleJobs === 0) {
                        var estTimeMins1Hr = estTimeMins - 60;
                        if (timeDiffMins < estTimeMins1Hr) {
                            error += "Difference between Arrival and Completion times is < Estimated Time (- 1 hr) \n";
                        }
                    }
                }
            }
        }
        //check if hours outside normal hours
        if (linkedJob.departureTimeFormatted) {
            if (DateHelpers.validTimeAmount(linkedJob.departureTimeFormatted) && !DateHelpers.isTimeInBusinessHours(linkedJob.departureTimeFormatted)) {
                error += "Departure Time is not within business hours \n"
            }
        }
        if (linkedJob.siteArrivalTimeFormatted) {
            if (DateHelpers.validTimeAmount(linkedJob.siteArrivalTimeFormatted) && !DateHelpers.isTimeInBusinessHours(linkedJob.siteArrivalTimeFormatted)) {
                error += "Arrival Time is not within business hours \n"
            }
        }
        if (linkedJob.siteCompletionTimeFormatted) {
            if (DateHelpers.validTimeAmount(linkedJob.siteCompletionTimeFormatted) && !DateHelpers.isTimeInBusinessHours(linkedJob.siteCompletionTimeFormatted)) {
                error += "Completed Time is not within business hours \n"
            }
        }

        if (error) {
            //remove the last \n
            error = error.substring(0, error.length - 2);
        }

        linkedJob.error = error;
        this.props.updateData(linkedJobs);
    }

    hideModal = () => {
        this.props.hideModal();
    }

    validate = () => {
        let errors: any = {};
        let formIsValid = true;

        let jobs = this.props.linkedJobs;
        var rowNumber = 0;

        var errorString = "Please enter the following values: ";
        var error = false;

        for (var i = 0; i < jobs.length; i++) {
            rowNumber += 1;
            var newErrorString = "";

            //only validate items that have been changed
            if (jobs[i].isDirty) {
                if (jobs[i].siteArrivalTimeFormatted == "") {
                    newErrorString += "Site Arrival Time, ";
                    error = true;
                }
                if (jobs[i].downTime && !DateHelpers.validTimeAmount(jobs[i].downTime)) {
                    newErrorString += "Valid Down Time, ";
                    error = true;
                }
                if (jobs[i].siteCompletionTimeFormatted == "") {
                    newErrorString += "Site Completion Time, ";
                    error = true;
                }

                var itemNumber = 0;
                for (var y = 0; y < jobs[i].items.length; y++) {
                    let ksItems = jobs[i].items[y].kwikstageItems;
                    if (ksItems && ksItems.length > 0) {
                        //kwikstage uses bays for totals instead of qty
                        for (var z = 0; z < jobs[i].items[y].kwikstageItems.length; z++) {
                            itemNumber += 1;
                            let totalqty = (jobs[i].items[y].kwikstageItems[z].baysComplete * 1) + (jobs[i].items[y].kwikstageItems[z].baysLost * 1);
                            if (!jobs[i].items[y].kwikstageItems[z].reschedule && totalqty != jobs[i].items[y].kwikstageItems[z].bays) {
                                newErrorString += "Item " + itemNumber + " - Actual Total + Lost Quantity must total Quantity Scheduled unless you are rescheduling, ";
                                error = true;
                            }
                        }
                    } else {
                        if (!jobs[i].items[y].reschedule && jobs[i].items[y].quantity < 1 && jobs[i].items[y].quantityLost == 0) {
                            newErrorString += "Item " + (y + 1) + " - Actual Quantity, ";
                            error = true;
                        }
                        var totalqty = +jobs[i].items[y].quantity + +jobs[i].items[y].quantityLost;
                        if (!jobs[i].items[y].reschedule && totalqty != jobs[i].items[y].quantityScheduled) {
                            newErrorString += "Item " + (y + 1) + " - Actual Quantity + Lost Quantity must total Quantity Scheduled unless you are rescheduling, ";
                            error = true;
                        }
                    }
                }
            }

            if (newErrorString != "") {
                errorString += "\n"
                errorString += "Row " + rowNumber + ": " + newErrorString;
                errorString = errorString.substring(0, errorString.length - 2);
            }

        }
        if (error) {
            formIsValid = false;
            errors["allocatedItems"] = errorString;
        }
        this.setState({ errors: errors });
        return formIsValid;
    }

    save = () => {
        this.setState({ truckFilterId: -1 })

        var jobsToReschedule = this.props.linkedJobs.filter(r => r.isReschedule);

        var changedItems = this.props.linkedJobs.filter(l => l.isDirty);
        if (changedItems && changedItems.length === 0 && jobsToReschedule && jobsToReschedule.length === 0) {
            toast.error("No items have changed!");
        } else {
            if (this.validate()) {
                this.setState({ errors: {} })
                this.props.saveModal();
            }
        }
    }

    render() {
        let contents = this.renderDetails();

        return <div>
            {contents}
        </div>;
    }

    renderDetails = () => {
        let linkedJobs = this.state.truckFilterId >= 0 ? this.props.linkedJobs.filter(j => j.truckId === (this.state.truckFilterId * 1)) : this.props.linkedJobs;
        let truckOptions = this.props.truckOptions;

        return (
            <Modal size="lg" show={this.props.showModal} onHide={this.hideModal}>
                <Modal.Header className="modal__header--colour">
                    <Modal.Title>Linked Jobs</Modal.Title>
                    <button type="button" className="close" onClick={this.hideModal}>&times;</button>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <div>
                            <label className="input-group--inline" htmlFor="truckFilterId">
                                <span className="label">Truck</span>
                                <select className="select" id="truckFilterId" name="truckFilterId" value={this.state.truckFilterId} onChange={(e) => this.handleTruckChange(e)}>
                                    <option defaultValue="-1" value="-1"></option>
                                    {truckOptions.map(truck =>
                                        <option key={truck.id} value={truck.id}>{truck.name}-{truck.registrationNumber}</option>
                                    )};
                                </select>
                            </label>
                        </div>
                        <div className="runsheetTable table__margin">
                            <table className="runsheetTable table table__large tableColours-header">
                                <thead>
                                    <tr>
                                        <th className="hidden">Id</th>
                                        <th>Truck</th>
                                        <th>Job Id</th>
                                        <th>Site Address</th>
                                        <th>Arrival</th>
                                        <th>Down Time</th>
                                        <th>Completion</th>
                                    </tr>
                                </thead>
                                {linkedJobs.map((job, index) =>
                                    <tbody className="runsheetRow" key={index}>
                                        <tr>
                                            <td className="hidden">{job.id}</td>
                                            <td className="table__text--align"> {job.truck}</td>
                                            <td className="table__text--align"> {job.jobId}</td>
                                            <td className="table__text--align">
                                                <div className={"tooltipitem tooltipitem__right"}>{job.siteAddress ? job.siteAddress.substring(0, 20) + "... " : ""}
                                                    <span className="tooltipitemtext tooltipitemtext__right">{job.siteAddress}</span>
                                                </div>
                                            </td>
                                            <td className="table__text--align">
                                                <input type="time" className="form-control runsheet__timeSize" id="siteArrivalTimeFormatted" name="siteArrivalTimeFormatted" value={job.siteArrivalTimeFormatted} onChange={(e) => this.onCellChange(job.itemIndex, e)} />
                                            </td>
                                            <td className="table__text--align">
                                                <input type='text' pattern="(0?[0-9]|1[0-2]):[0-5][0-9]$" className="form-control runsheet__timeSize" id="downTime" name="downTime" value={job.downTime} onChange={(e) => this.onCellChange(job.itemIndex, e)} />
                                            </td>
                                            <td className="table__text--align">
                                                <input type="time" className="form-control runsheet__timeSize" id="siteCompletionTimeFormatted" name="siteCompletionTimeFormatted" value={job.siteCompletionTimeFormatted} onChange={(e) => this.onCellChange(job.itemIndex, e)} />
                                            </td>
                                        </tr>
                                        <tr className={job.error === "" ? "hidden" : ""}>
                                            <td className="makeitred" colSpan={11}>
                                                {
                                                    job.error.split("\n").map((item: any, key: any) => {
                                                        return <span className="label errors" key={key}>{item}<br /></span>
                                                    })
                                                }
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan={11}>
                                                <table className='table subtable tableColours-header'>
                                                    <thead>
                                                        <tr>
                                                            <th className="hidden">Id</th>
                                                            <th>Unit #</th>
                                                            <th>Item</th>
                                                            <th>Sched Qty</th>
                                                            <th>
                                                                <div className="tooltipitem tooltipitem__right">Actual Total
                                                                    <span className="tooltipitemtext tooltipitemtext__right">Quantity completed during the time period</span>
                                                                </div>
                                                            </th>
                                                            <th>
                                                                <div className="tooltipitem tooltipitem__right">Lost
                                                                    <span className="tooltipitemtext tooltipitemtext__right">Any lost, stolen or damaged items, note the quantity here</span>
                                                                </div>
                                                            </th>
                                                            <th>
                                                                <div className="tooltipitem tooltipitem__right">Re-Schedule
                                                                    <span className="tooltipitemtext tooltipitemtext__right">Tick the box if the job needs to roll over</span>
                                                                </div>
                                                            </th>
                                                            <th>Edit</th>
                                                        </tr>
                                                    </thead>
                                                    {job.items.map((item, index) =>
                                                        <React.Fragment key={index}>
                                                            <tbody className={item.kwikstageItems.length === 0 ? "" : "hidden"}>
                                                                <RunsheetRow index={index} job={job} item={item} editJob={this.editJob} onSubgridCellChange={this.onSubgridCellChange} onSubgridCellCheckChange={this.onSubgridCellCheckChange} />
                                                            </tbody>
                                                            <tbody className={item.kwikstageItems.length === 0 ? "hidden" : ""}>
                                                                {item.kwikstageItems.map((ksItem, ksIndex) =>
                                                                    <RunsheetKwikstageRow key={ksItem.scheduleKwikstageId} ksIndex={ksIndex} job={job} item={item} ksItem={ksItem} editJob={this.editJob} onKwikstageSubgridCellChange={this.onKwikstageSubgridCellChange} onKwikstageSubgridCheckChange={this.onKwikstageSubgridCheckChange} />
                                                                )}
                                                            </tbody>
                                                        </React.Fragment>
                                                    )}
                                                </table>

                                            </td>
                                        </tr>
                                    </tbody>
                                )}
                            </table>
                            {this.state.errors["allocatedItems"] ?
                                (this.state.errors["allocatedItems"]).split("\n").map((item: any, key: any) => {
                                    return <span className="label errors" key={key}>{item}<br /></span>
                                })
                                : ""}
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="popup-button--yes" onClick={this.save}>Save</button>
                </Modal.Footer>
            </Modal>

        )
    }
}

const RunsheetRow = ({ index, job, item, editJob, onSubgridCellChange, onSubgridCellCheckChange }: { index: number, job: AllocatedJob, item: AllocatedJobItem, editJob(e: any, jobIndex: number, itemIndex: number): void, onSubgridCellChange(jobIndex: number, itemIndex: number, e: any): void, onSubgridCellCheckChange(jobIndex: number, itemIndex: number, e: any): void }) => {
    return (
        <tr key={index} className={item.typeId === 1 && item.isCustomerPickup ? "tableColours--cust--install" : item.typeId === 1 ? "tableColours--install" : item.typeId === 2 && item.isCustomerPickup ? "tableColours--cust--pickup" : item.typeId === 2 ? "tableColours--pickup" : item.typeId === 3 ? "tableColours--assist" : "tableColours--cleaning"}>
            <td className="hidden">{item.id}</td>
            <td className="table__text--align">{item.unitNumber}</td>
            <td className="table__text--align">
                <div className="tooltipitem tooltipitem__right">{item.manualItem || (item.calloutItem && item.description != "") ? item.description.substring(0, 30) + "... " : item.item}
                    <span className="tooltipitemtext tooltipitemtext__right">{item.manualItem || (item.calloutItem && item.description != "") ? item.description : item.item}</span>
                </div>
            </td>
            <td className="table__text--align">{item.quantityType}</td>
            <td className="table__text--align">
                <input type='number' min={0} step={1} className="form-control allocate__qtySize" value={item.quantity} id="quantity" name="quantity" onChange={(e) => onSubgridCellChange(job.itemIndex, item.itemIndex, e)} />
            </td>
            <td className="table__text--align">
                <input type='number' min={0} step={1} className="form-control allocate__qtySize" value={item.quantityLost} id="quantityLost" name="quantityLost" onChange={(e) => onSubgridCellChange(job.itemIndex, item.itemIndex, e)} />
            </td>
            <td className="table__text--align">
                <input type='checkbox' className="input-control" checked={item.reschedule} id="reschedule" name="reschedule" onChange={(e) => onSubgridCellCheckChange(job.itemIndex, item.itemIndex, e)} disabled={item.manualItem} />
            </td>
            <td className="table__text--align">
                <a className={item.type == "Install" && !item.manualItem ? "" : "hidden"} href="#" onClick={(e) => editJob(e, job.itemIndex, item.itemIndex)}>
                    <span className="fas fa-folder-open copy--icon alignIconCenter tooltipitem tooltipitem__left"><span className="tooltipitemtext tooltipitemtext__left">Edit job if changes to plan (USE CAUTION)</span></span>
                </a>
            </td>
        </tr>
    )
};

const RunsheetKwikstageRow = ({ ksIndex, job, item, ksItem, editJob, onKwikstageSubgridCellChange, onKwikstageSubgridCheckChange }: { ksIndex: number, job: AllocatedJob, item: AllocatedJobItem, ksItem: AllocateJobKwikstageItem, editJob(e: any, jobIndex: number, itemIndex: number): void, onKwikstageSubgridCellChange(e: any, jobIndex: number, itemIndex: number, kwikstageIndex: number): void, onKwikstageSubgridCellChange(e: any, jobIndex: number, itemIndex: number, kwikstageIndex: number): void, onKwikstageSubgridCheckChange(e: any, jobIndex: number, itemIndex: number, kwikstateIndex: number): void }) => {
    return (
        <tr key={ksItem.scheduleKwikstageId} className={item.typeId === 1 ? "tableColours--install" : item.typeId === 2 ? "tableColours--pickup" : item.typeId === 3 ? "tableColours--assist" : "tableColours--cleaning"}>
            <td className="hidden">{item.id}</td>
            <td className="table__text--align">{item.unitNumber}</td>
            <td className="table__text--align">
                <div className="tooltipitem tooltipitem__right">{item.manualItem || (item.calloutItem && item.description != "") ? item.description.substring(0, 30) + "... " : item.item}
                    <span className="tooltipitemtext tooltipitemtext__right">{item.manualItem || (item.calloutItem && item.description != "") ? item.description : item.item}</span>
                </div>
            </td>
            <td className="table__text--align">{ksItem.bays + " " + ksItem.starterBay + " - " + ksItem.lift + " bays"}</td>
            <td className="table__text--align">
                <input type='number' min={0} step={1} className="form-control allocate__qtySize" value={ksItem.baysComplete} id="baysComplete" name="baysComplete" onChange={(e) => onKwikstageSubgridCellChange(e, job.itemIndex, item.itemIndex, ksIndex)} />
            </td>
            <td className="table__text--align">
                <input type='number' min={0} step={1} className="form-control allocate__qtySize" value={ksItem.baysLost} id="baysLost" name="baysLost" onChange={(e) => onKwikstageSubgridCellChange(e, job.itemIndex, item.itemIndex, ksIndex)} />
            </td>
            <td className="table__text--align">
                <input type='checkbox' className="input-control" checked={ksItem.reschedule} id="reschedule" name="reschedule" onChange={(e) => onKwikstageSubgridCheckChange(e, job.itemIndex, item.itemIndex, ksIndex)} disabled={item.manualItem} />
            </td>
            <td className="table__text--align">
                <a className={item.type == "Install" && !item.manualItem ? "" : "hidden"} href="#" onClick={(e) => editJob(e, job.itemIndex, item.itemIndex)}>
                    <span className="fas fa-folder-open copy--icon alignIconCenter tooltipitem tooltipitem__left"><span className="tooltipitemtext tooltipitemtext__left">Edit job if changes to plan (USE CAUTION)</span></span>
                </a>
            </td>
        </tr>
    )
};
